import { render, staticRenderFns } from "./RutasDetallesSkeleton.vue?vue&type=template&id=195a4b9b&"
import script from "./RutasDetallesSkeleton.vue?vue&type=script&lang=js&"
export * from "./RutasDetallesSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
